// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2_MjY","label":"styles_label__2baYB"};